import type { ReachKind } from '@/pages/discovered/types'

// Both modes reuse these ids so filter state survives the toggle; a rename must cover every use.
export const DISCOVERY_COLUMN_IDS = {
  reach: 'reach',
  cloudAccountCounts: 'cloudAccountCounts',
  sources: 'sources',
  permissions: 'permissions',
  relatedThirdParty: 'relatedThirdParty',
  assignee: 'assignee',
  /** The only visible column while grouped: the third-party master row. */
  thirdPartyGroup: 'thirdPartyGroup',
  /** Filter-only column that carries the AI Posture filter for the related third-party. */
  aiPosture: 'aiPosture',
} as const

/** The Reach column shows both dimensions at once, so each filters through a column of its own. */
export const DISCOVERY_REACH_FILTER_IDS = {
  devices: 'reachDevices',
  users: 'reachUsers',
} as const satisfies Record<ReachKind, string>

/** Filters offered while grouped; each needs a filter-only column over the group's values.
 * Environment stays behind "Add filter", as designed. */
export const DISCOVERY_GROUPED_FILTER_IDS = [
  DISCOVERY_COLUMN_IDS.sources,
  DISCOVERY_COLUMN_IDS.permissions,
  DISCOVERY_REACH_FILTER_IDS.devices,
  DISCOVERY_REACH_FILTER_IDS.users,
  DISCOVERY_COLUMN_IDS.relatedThirdParty,
  DISCOVERY_COLUMN_IDS.assignee,
  DISCOVERY_COLUMN_IDS.aiPosture,
] as const
